import classNames from "classnames";
import { get } from "lodash";
import React from "react";
import Container from "~/components/Container";
import Divider from "~/components/Divider";
import Star from "~/components/Star";
import Text from "~/components/Text";
import Colors from "~/constants/colors";
import { Product } from "~/services/product";
import styles from "./ProductDetailSimilar.module.scss";
import Button from "~/components/Button";
import { getUrlCustom } from "~/utils/theme";
import { PATH } from "~/constants/enum";

type Props = {
  product: Product;
};

const ProductDetailSimilar = ({ product }: Props) => {
  if (!product) {
    return "Component Loading...";
  }
  return (
    <Container className="flex flex-row xs:gap-4 px-0">
      <div className="w-1/3 aspect-[16/9] text-center overflow-hidden">
        {/* lấy hình trong bộ variant trùng & là variant đầu tiên */}
        {/* Chỉ cần thay cái hình vị trí thứ 0 */}
        <div className="relative w-full aspect-square">
          <img
            className="object-cover w-full h-full"
            src={product.image.url}
            alt={product.name}
          />
        </div>
      </div>
      <div className="flex flex-col flex-1 gap-1 px-4 ">
        <div className="flex flex-col justify-start gap-2">
          <div className="flex items-center">
            <a
              href={getUrlCustom({
                pathname: PATH.ProductDetail,
                query: {
                  slug: product.url_key,
                },
              })}
            >
              <h1
                className="font-semibold hover:underline hover:cursor-pointer"
                style={{ lineHeight: "125%" }}
              >
                {product?.name}
              </h1>
            </a>
          </div>
          <div className="flex justify-between">
            {!!product?.review_count && (
              <div
                title={product?.rating_summary + ""}
                className="flex items-center gap-2 cursor-pointer"
              >
                <Star value={product?.rating_summary} size={16} />{" "}
                <span className="underline text-sm">{`(${product?.review_count})`}</span>
              </div>
            )}
          </div>
          <div className="flex items-center gap-1 flex-wrap">
            <Text type="headline-3" weight={800} color={Colors.PRIMARY}>
              {get(
                product,
                "price_range.minimum_price.final_price.symbol",
                "$"
              )}
              {get(
                product,
                "price_range.minimum_price.final_price.value"
              )?.toFixed(2)}
            </Text>
            {!!product?.price_range?.minimum_price?.discount?.percent_off && (
              <small
                className="line-through"
                style={{
                  color: Colors.GREY_400,
                }}
              >
                {get(
                  product,
                  "price_range?.minimum_price.regular_price.symbol",
                  "$"
                )}
                {get(
                  product,
                  "price_range.minimum_price.regular_price.value"
                )?.toFixed(2)}
              </small>
            )}
            <div className={classNames("ml-2", styles.tags)}>
              {!!product.price_range?.minimum_price?.discount?.percent_off && (
                <div className={classNames(styles.tag_item, styles.discount)}>
                  <Text>{`${product.price_range?.minimum_price?.discount?.percent_off}% off`}</Text>
                </div>
              )}

              {product.badges?.map((badge) => (
                <div
                  key={badge}
                  className={classNames(styles.tag_item, styles[badge])}
                >
                  <Text>{badge}</Text>
                </div>
              ))}
              {/* {!!isFreeShip && (
                <div className={classNames(styles.tag_item, styles.freeShip)}>
                  <Text>{isFreeShip?.title} </Text>
                </div>
              )} */}
            </div>
          </div>
        </div>

        <a
          href={getUrlCustom({
            pathname: PATH.ProductDetail,
            query: {
              slug: product.url_key,
            },
          })}
        >
          <Button type="outline" className="mt-3">
            Shop this item
          </Button>
        </a>
      </div>
    </Container>
  );
};

export default ProductDetailSimilar;
